module.exports = __webpack_public_path__ + "static/media/checked-circle.3353a853.svg";